//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  ao: "అంగోలా",
  aq: "అంటార్కిటికా",
  az: "అజర్బైజాన్",
  as: "అమెరికన్ సమోవా",
  aw: "అరుబా",
  ar: "అర్జెంటీనా",
  dz: "అల్జీరియా",
  al: "అల్బేనియా",
  ai: "ఆంగ్విల్లా",
  ag: "ఆంటిగ్వా మరియు బార్బుడా",
  ad: "ఆండోరా",
  af: "ఆఫ్ఘనిస్తాన్",
  am: "ఆర్మేనియా",
  ax: "ఆలాండ్ దీవులు",
  at: "ఆస్ట్రియా",
  au: "ఆస్ట్రేలియా",
  id: "ఇండోనేషియా",
  il: "ఇజ్రాయెల్",
  it: "ఇటలీ",
  et: "ఇథియోపియా",
  iq: "ఇరాక్",
  ir: "ఇరాన్",
  gq: "ఈక్వటోరియల్ గినియా",
  ec: "ఈక్వడార్",
  eg: "ఈజిప్ట్",
  sz: "ఈస్వాటిని",
  ua: "ఉక్రెయిన్",
  ug: "ఉగాండా",
  uz: "ఉజ్బెకిస్తాన్",
  kp: "ఉత్తర కొరియా",
  mp: "ఉత్తర మరియానా దీవులు",
  mk: "ఉత్తర మాసిడోనియా",
  uy: "ఉరుగ్వే",
  er: "ఎరిట్రియా",
  sv: "ఎల్ సాల్వడోర్",
  ee: "ఎస్టోనియా",
  ie: "ఐర్లాండ్",
  im: "ఐల్ ఆఫ్ మాన్",
  is: "ఐస్లాండ్",
  om: "ఓమన్",
  kh: "కంబోడియా",
  kz: "కజకిస్తాన్",
  bq: "కరీబియన్ నెదర్లాండ్స్",
  cd: "కాంగో- కిన్షాసా",
  cg: "కాంగో- బ్రాజావిల్లి",
  cm: "కామెరూన్",
  ki: "కిరిబాటి",
  kg: "కిర్గిజిస్తాన్",
  ck: "కుక్ దీవులు",
  kw: "కువైట్",
  ca: "కెనడా",
  ke: "కెన్యా",
  cv: "కేప్ వెర్డె",
  ky: "కేమాన్ దీవులు",
  km: "కొమొరోస్",
  co: "కొలంబియా",
  cc: "కోకోస్ (కీలింగ్) దీవులు",
  ci: "కోట్ డి ఐవోర్",
  cr: "కోస్టా రికా",
  cu: "క్యూబా",
  cw: "క్యూరసో",
  cx: "క్రిస్మస్ దీవి",
  nc: "క్రొత్త కాలెడోనియా",
  hr: "క్రొయేషియా",
  qa: "ఖతార్",
  gy: "గయానా",
  gg: "గర్న్‌సీ",
  gm: "గాంబియా",
  gn: "గినియా",
  gw: "గినియా-బిస్సావ్",
  ga: "గేబన్",
  gl: "గ్రీన్‌ల్యాండ్",
  gr: "గ్రీస్",
  gd: "గ్రెనడా",
  gt: "గ్వాటిమాలా",
  gp: "గ్వాడెలోప్",
  gu: "గ్వామ్",
  gh: "ఘనా",
  td: "చాద్",
  cl: "చిలీ",
  cz: "చెకియా",
  cn: "చైనా",
  jp: "జపాన్",
  jm: "జమైకా",
  de: "జర్మనీ",
  zm: "జాంబియా",
  ge: "జార్జియా",
  zw: "జింబాబ్వే",
  dj: "జిబౌటి",
  gi: "జిబ్రాల్టర్",
  je: "జెర్సీ",
  jo: "జోర్డాన్",
  tr: "టర్కీ",
  tm: "టర్క్‌మెనిస్తాన్",
  tc: "టర్క్స్ మరియు కైకోస్ దీవులు",
  tz: "టాంజానియా",
  tl: "టిమోర్-లెస్టె",
  tv: "టువాలు",
  to: "టోంగా",
  tk: "టోకెలావ్",
  tg: "టోగో",
  tn: "ట్యునీషియా",
  tt: "ట్రినిడాడ్ మరియు టొబాగో",
  dk: "డెన్మార్క్",
  do: "డొమినికన్ రిపబ్లిక్",
  dm: "డొమినికా",
  tj: "తజికిస్తాన్",
  tw: "తైవాన్",
  th: "థాయిలాండ్",
  za: "దక్షిణ ఆఫ్రికా",
  kr: "దక్షిణ కొరియా",
  gs: "దక్షిణ జార్జియా మరియు దక్షిణ శాండ్విచ్ దీవులు",
  ss: "దక్షిణ సూడాన్",
  na: "నమీబియా",
  nf: "నార్ఫోక్ దీవి",
  no: "నార్వే",
  ni: "నికరాగువా",
  nu: "నియూ",
  nl: "నెదర్లాండ్స్",
  np: "నేపాల్",
  ne: "నైజర్",
  ng: "నైజీరియా",
  nr: "నౌరు",
  nz: "న్యూజిలాండ్",
  eh: "పడమటి సహారా",
  pa: "పనామా",
  py: "పరాగ్వే",
  pk: "పాకిస్తాన్",
  pg: "పాపువా న్యూ గినియా",
  ps: "పాలస్తీనియన్ ప్రాంతాలు",
  pw: "పాలావ్",
  pn: "పిట్‌కెయిర్న్ దీవులు",
  pe: "పెరూ",
  pt: "పోర్చుగల్",
  pl: "పోలాండ్",
  pr: "ప్యూర్టో రికో",
  fk: "ఫాక్‌ల్యాండ్ దీవులు",
  fo: "ఫారో దీవులు",
  fj: "ఫిజీ",
  fi: "ఫిన్లాండ్",
  ph: "ఫిలిప్పైన్స్",
  fr: "ఫ్రాన్స్‌",
  gf: "ఫ్రెంచ్ గియానా",
  tf: "ఫ్రెంచ్ దక్షిణ ప్రాంతాలు",
  pf: "ఫ్రెంచ్ పోలినీషియా",
  bd: "బంగ్లాదేశ్",
  bg: "బల్గేరియా",
  bs: "బహామాస్",
  bh: "బహ్రెయిన్",
  bb: "బార్బడోస్",
  bi: "బురుండి",
  bf: "బుర్కినా ఫాసో",
  bv: "బువై దీవి",
  bj: "బెనిన్",
  bm: "బెర్ముడా",
  by: "బెలారస్",
  bz: "బెలిజ్",
  be: "బెల్జియం",
  bo: "బొలీవియా",
  bw: "బోట్స్వానా",
  ba: "బోస్నియా మరియు హెర్జిగోవినా",
  vg: "బ్రిటిష్ వర్జిన్ దీవులు",
  io: "బ్రిటిష్ హిందూ మహాసముద్ర ప్రాంతం",
  bn: "బ్రూనే",
  br: "బ్రెజిల్",
  in: "భారతదేశం",
  bt: "భూటాన్",
  mn: "మంగోలియా",
  mo: "మకావ్ ఎస్ఏఆర్ చైనా",
  mg: "మడగాస్కర్",
  mm: "మయన్మార్",
  mw: "మలావీ",
  my: "మలేషియా",
  me: "మాంటెనెగ్రో",
  ms: "మాంట్సెరాట్",
  yt: "మాయొట్",
  mu: "మారిషస్",
  mq: "మార్టినీక్",
  mh: "మార్షల్ దీవులు",
  ml: "మాలి",
  mt: "మాల్టా",
  mv: "మాల్దీవులు",
  mx: "మెక్సికో",
  fm: "మైక్రోనేషియా",
  mz: "మొజాంబిక్",
  mc: "మొనాకో",
  ma: "మొరాకో",
  md: "మోల్డోవా",
  mr: "మౌరిటేనియా",
  vi: "యు.ఎస్. వర్జిన్ దీవులు",
  ae: "యునైటెడ్ అరబ్ ఎమిరేట్స్",
  gb: "యునైటెడ్ కింగ్‌డమ్",
  us: "యునైటెడ్ స్టేట్స్",
  ye: "యెమెన్",
  ru: "రష్యా",
  re: "రీయూనియన్",
  rw: "రువాండా",
  ro: "రోమేనియా",
  lu: "లక్సెంబర్గ్",
  lv: "లాత్వియా",
  la: "లావోస్",
  li: "లిక్టెన్‌స్టెయిన్",
  lt: "లిథువేనియా",
  ly: "లిబియా",
  lb: "లెబనాన్",
  ls: "లెసోతో",
  lr: "లైబీరియా",
  vu: "వనాటు",
  va: "వాటికన్ నగరం",
  wf: "వాల్లిస్ మరియు ఫుటునా",
  vn: "వియత్నాం",
  ve: "వెనిజులా",
  sm: "శాన్ మారినో",
  lk: "శ్రీలంక",
  um: "సంయుక్త రాజ్య అమెరికా బయట ఉన్న దీవులు",
  ws: "సమోవా",
  st: "సావో టోమ్ మరియు ప్రిన్సిపి",
  sg: "సింగపూర్",
  sx: "సింట్ మార్టెన్",
  sl: "సియెర్రా లియాన్",
  sy: "సిరియా",
  sc: "సీషెల్స్",
  sd: "సూడాన్",
  sr: "సూరినామ్",
  cf: "సెంట్రల్ ఆఫ్రికన్ రిపబ్లిక్",
  sn: "సెనెగల్",
  kn: "సెయింట్ కిట్స్ మరియు నెవిస్",
  pm: "సెయింట్ పియెర్ మరియు మికెలాన్",
  bl: "సెయింట్ బర్థెలిమి",
  mf: "సెయింట్ మార్టిన్",
  lc: "సెయింట్ లూసియా",
  vc: "సెయింట్ విన్సెంట్ మరియు గ్రెనడీన్స్",
  sh: "సెయింట్ హెలెనా",
  rs: "సెర్బియా",
  cy: "సైప్రస్",
  so: "సోమాలియా",
  sb: "సోలమన్ దీవులు",
  sa: "సౌదీ అరేబియా",
  es: "స్పెయిన్",
  sk: "స్లొవేకియా",
  si: "స్లోవేనియా",
  sj: "స్వాల్‌బార్డ్ మరియు జాన్ మాయెన్",
  ch: "స్విట్జర్లాండ్",
  se: "స్వీడన్",
  hu: "హంగేరీ",
  hk: "హాంకాంగ్ ఎస్ఏఆర్ చైనా",
  hm: "హెర్డ్ దీవి మరియు మెక్‌డొనాల్డ్ దీవులు",
  ht: "హైటి",
  hn: "హోండురాస్",
};
